"use strict";var getEnvironDomain=require("../getEnvironDomain-12250831.js");module.exports=getEnvironDomain.getEnvironDomain;
